import React from 'react';

export const ScoreBar = ({ color, score }) => {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '360px',
        height: '15px',
        borderRadius: '9999px',
        background: '#fff',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          width: 'inherit',
          height: '100%',
          borderRadius: 'inherit',
          background: `${color}25`,
        }}
      >
        <div
          style={{
            width: `${score}%`,
            height: '100%',
            borderRadius: 'inherit',
            background: color,
            transition: 'all 0.3s',
          }}
        />
      </div>
    </div>
  );
};
